import React, { useEffect, useRef, memo } from "react";
import Swiper from "swiper";
import "../Swiper.css";
import "../dm-slide.css";

const DMMediaSlider = ({
  file,
  mediaLinks,
  fullLinks,
  setImages,
  setSlideIndex
}) => {
  const swip = useRef(null);
  useEffect(() => {
    if (swip.current) {
      new Swiper(swip.current, {
        // Optional parameters
        loop: true,
        // If we need pagination
        pagination: {
          el: ".swiper-pagination"
        }
      });
    }
  }, []);
  return (
    <div className="swiper-container dmSlide" ref={swip}>
      <div className="swiper-wrapper">
        {mediaLinks.map((link, index) => (
          <div
            className="swiper-slide"
            key={`${file}-${index}`}
            onClick={() => {
              setImages(fullLinks);
              setSlideIndex(index);
            }}
          >
            <img src={link} alt={`image # ${index}`} />
          </div>
        ))}
      </div>

      <div className="swiper-pagination"></div>
    </div>
  );
};

export default memo(DMMediaSlider);
